import reduceReducers from "reduce-reducers";

import {
  BUSINESS,
  DEPLOYMENT,
  VENDOR_COMMISSION_BAND,
} from "constants/actionTypes";

import { apiModelOfflineFetchReducer } from "lib/reducers";
import { deserializeVendorCommissionBand } from "lib/serializers/vendorCommissionBands";

const fetch = apiModelOfflineFetchReducer(VENDOR_COMMISSION_BAND, {
  deserializer: deserializeVendorCommissionBand,
});

function deploymentBusinessReducer(state, action) {
  switch (action.type) {
    case BUSINESS.UPDATE.REQUEST:
    case BUSINESS.CREATE.REQUEST: {
      const { payload } = action;
      const { vendor_commission_bands, id: businessId } = payload;
      if (Array.isArray(vendor_commission_bands) && businessId) {
        const newBandsById = vendor_commission_bands.reduce((byId, band) => {
          byId[band.id] = deserializeVendorCommissionBand({
            ...band,
            business_id: businessId,
          });
          return byId;
        }, {});

        const byId = Object.values(state.byId).reduce((acc, band) => {
          // Re-add if:
          // not in the new dataset
          // not linked to the business whose commissions are being replaced
          if (
            !acc[band.id] &&
            (!band.businessId || band.businessId !== businessId)
          ) {
            acc[band.id] = band;
          }

          return acc;
        }, newBandsById);
        return {
          ...state,
          byId,
        };
      }
      return state;
    }
    default:
      return state;
  }
}

function deploymentReducer(state, action) {
  switch (action.type) {
    case DEPLOYMENT.UPDATE.REQUEST: {
      const { payload } = action;
      const { vendor_commission_bands, id } = payload;
      if (Array.isArray(vendor_commission_bands) && id) {
        const newBandsById = vendor_commission_bands.reduce((byId, band) => {
          byId[band.id] = deserializeVendorCommissionBand({
            ...band,
            deployment_id: id,
            business_id: null,
          });
          return byId;
        }, {});

        const byId = Object.values(state.byId).reduce((acc, band) => {
          // Re-add if:
          // not in the new dataset
          // not a deployment default band
          if (!acc[band.id] && band.businessId != null) {
            acc[band.id] = band;
          }

          return acc;
        }, newBandsById);
        return {
          ...state,
          byId,
        };
      }
      return state;
    }
    default:
      return state;
  }
}

const vendorCommissionBandReducer = reduceReducers(
  fetch,
  deploymentBusinessReducer,
  deploymentReducer,
);

export default vendorCommissionBandReducer;
